import type { ChatMessage } from '@elara/client-core/models/ChatMessageModel';
import type { MessageUiState } from '@elara/client-core/states/MessageUiState';

import { cn } from '@elara/client-core/lib/utils';

import { useChatsState, useUIState, useUserProfileState } from '#states/hooks.js';
import { MessageContentRenderer } from '#ui/chat/MessageContentRenderer.js';
import { Avatar, AvatarFallback, AvatarImage } from '#ui/index.js';

interface UserMessageCardProps {
  msg: ChatMessage;
  state: MessageUiState;
}

export function UserMessageCard({ msg, state }: UserMessageCardProps) {
  const uiState = useUIState();
  const userProfileState = useUserProfileState();
  const chatsState = useChatsState();
  const currentChat = chatsState.current;

  const multipleParticipants = currentChat?.participants && currentChat?.participants.length > 2;

  return (
    <div
      className={cn(
        'relative px-3 py-2 rounded-xl rounded-tr-sm transition-colors duration-300 ml-10',
        'bg-background-tertiary',
      )}
    >
      <div
        className={cn(
          msg.status === 'sending' || msg.status === 'receiving' || msg.isStreaming ? 'animate-pulse' : null,
        )}
      >
        {state.content.length > 0 ? <MessageContentRenderer content={state.content} state={state} /> : 'Empty'}
      </div>

      {multipleParticipants && (
        <div className="absolute -bottom-2.5 -right-2.5 border-2 border-background-primary rounded-full">
          <Avatar className="h-5 w-5">
            <AvatarImage
              src={userProfileState.profile?.photoURL || undefined}
              alt={userProfileState.profile?.displayName || 'User'}
            />
            <AvatarFallback>{userProfileState.profile?.initials}</AvatarFallback>
          </Avatar>
        </div>
      )}
    </div>
  );
}
